import Api from  "@/services/AxiosAPI";

export default {

  getProductDetails(url) {
    return Api.getData('/productsinfo/'+url).then(response =>{
      return response.data.data;
    })
  }
  ,

  getEcourse(url){
    return Api.getData('/productsinfo/'+url)
      .then(response =>{
        return response.data.data;
      })
  },

  orders(id) {

    return Api.getData('products/' + id)
      .then(response => {
        return response.data.data;
      })
  },
  getCourseVenue(){
    return Api.getData('training-course/citb-site-safety-plus-health-and-safety-awareness')
      .then(response =>{
        return response.data;
      })
  },
  getDetails(url) {
    return Api.getData('/help/'+url).then(response =>{
      return response.data;
    })
  },
  getVenueDetail(id) {
    return Api.getData('/venue/'+id).then(response =>{
      return response.data;
    })
  },
  checkTrainee(courseId, firstName, lastName) {
    return Api.getData('/check-trainee/'+courseId+"/"+firstName+"%20"+lastName).then(response =>{
      return response.data;
    })
  }
}